import { useSuspenseQuery, UseSuspenseQueryOptions } from "@tanstack/react-query";
import { Profile } from "@/types";
import { api, ErrorResponse } from "@/utils/api";
import { camelize } from "@/utils/api-helpers";

export const useProfile = (
  options: Omit<UseSuspenseQueryOptions<unknown, ErrorResponse, Profile>, "queryKey"> = {}
) => {
  return useSuspenseQuery<unknown, ErrorResponse, Profile>({
    queryKey: ["profile"],
    queryFn: async (): Promise<Profile> => {
      const response = await api.get<Profile>(`/profile`);
      return camelize(response.data);
    },
    ...options
  });
};
